import { render, staticRenderFns } from "./BookViewer (deprecated).vue?vue&type=template&id=15fd98b8&"
import script from "./BookViewer (deprecated).vue?vue&type=script&lang=js&"
export * from "./BookViewer (deprecated).vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports